import type {
  DocChatConversation,
  DocumentTab,
} from 'features/knowledgeDocumentViewer/types'

export function pendingAgenticConversationKey(tabId: string): string {
  return `pending:${tabId}`
}

export function agenticConversationSessionKey(
  conversation: Pick<DocChatConversation, 'id' | 'pendingSessionKey'>,
  tabId: string
): string {
  return (
    conversation.id ??
    conversation.pendingSessionKey ??
    pendingAgenticConversationKey(tabId)
  )
}

export function resolveAgenticConversationIdentity(
  tab: DocumentTab,
  siteId?: string
): { conversation: DocChatConversation; key: string } | undefined {
  const item = tab.history[tab.currentIndex]
  if (item.type !== 'search') return undefined
  const docChat = item.searchState.docChat
  if (!docChat) return undefined
  if (siteId !== undefined && docChat.siteId !== siteId) return undefined
  const { conversation } = docChat
  if (conversation.turns.length === 0 && item.searchState.chatOnly !== true) {
    return undefined
  }
  return {
    conversation,
    key: agenticConversationSessionKey(conversation, tab.id),
  }
}

export function getAgenticConversationId(tab: DocumentTab): string | undefined {
  return resolveAgenticConversationIdentity(tab)?.conversation.id
}

export function getAgenticConversationKey(
  tab: DocumentTab
): string | undefined {
  return resolveAgenticConversationIdentity(tab)?.key
}
